import { init } from '@fullstory/browser';

import Config from '../config';

init({
  orgId: Config.FULLSTORY_ORG_ID,
  devMode: Config.ENVIRONMENT !== 'production',
});
